import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ProductData, TagData } from "../../types";
import { useAPI } from "../../hooks/useAPI";
import { useAuth } from "../../assets/contexts/AuthContext";
import { Box, Button, FormGroup, Modal, Select, Stack, TextField, Typography } from "@mui/material";
import { ConfirmDialog } from "../../components/global/ConfirmDialog";
import { useConfirmDialog } from "../../hooks/useConfirmDialog";

interface EditTagModal {
  refetchTags: () => void;
}

export const EditTagModal = ({refetchTags }: EditTagModal) => {
  const { tag_id } = useParams();
  const [tag, setTag] = useState<TagData>();
  const [products, setProducts] = useState<ProductData[]>([]);
  const { fetchData } = useAPI();
  const navigate = useNavigate();
  const isLoading = useRef(false);
  const { isAuthenticated } = useAuth();
  const [open, setOpen] = useState(false);
  const { isOpen, config, openDialog, closeDialog } = useConfirmDialog();

  const refetchProducts = async (tag: TagData) => {
    const {errors, data} = await fetchData(`/products/all?client_id=${tag.client_id}`);
    setProducts(data);
    setOpen(true);
  }

  useEffect(() => {
    if (isAuthenticated && !isLoading.current) {
      isLoading.current = true;

      fetchData(`/tags/${tag_id}`).then(({ errors, data }) => {
        isLoading.current = false;
        setTag(data);
        refetchProducts(data);
      }).catch(error => {
        isLoading.current = false;
        console.log(error);
      })
    }
  }, [isAuthenticated, tag_id]);

  const handleClose = () => {
    setOpen(false);
  }

  const handleSave = () => {
    navigate('/tags');
    setOpen(false);
    refetchTags();
  }

  const onSaveTag = async (mTag?: TagData) => {
    if (mTag) {
      const {errors, data} = await fetchData('/tags/save',  mTag, 'POST');
      if (errors) {
        console.error(errors);
      } else {
        handleSave();
      }
    }
  }

  const onDeleteTag = async (mTag?: TagData) => {
    if (mTag) {
      const {errors, data} = await fetchData('/tags/delete',  { id: mTag.id }, 'POST');
      if (errors) {
        console.error(errors);
      } else {
        handleSave();
      }
    }
  }
  
  return (
    <Modal
      open={open}
      // onClose={handleClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box sx={{ 
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '80%',
        maxWidth: '750px',
        bgcolor: 'background.paper',
        border: '1px solid #909894',
        boxShadow: '0px 4px 4px 0px #00000040',
        borderRadius:'16px',
        p: 4,
        maxHeight: '90%',
        overflow: 'auto',
       }}>
        <Typography id="modal-title" variant="h4" component="h2" fontWeight="600"> Edit Tag </Typography>
        <Stack mt={4} spacing={4}>
          <FormGroup>
            <Typography fontWeight="600">Product</Typography>
            <Select 
              native
              variant="outlined"
              value={tag?.product_id ?? ''}
              onChange={(e) => setTag({ ...tag, product_id: e.target.value })}
              sx={{ width: '100%' }}
            >
              <option></option>
              {
                products.map((item: any, index: number) => (
                  <option key={index} value={item?.id}>{item?.name}</option>
                ))
              }
            </Select>
          </FormGroup>
          <FormGroup>
            <Stack direction='row' spacing={2}>
              <Button variant="contained" size="large" onClick={() => onSaveTag(tag)}>
                Save Tag
              </Button>
              {
                <Button variant="outlined" size="large" color="error" onClick={() => 
                  openDialog(
                    "Confirm Deletion",
                    `Are you sure you want to delete the client "${tag?.uuid}"?`,
                    () => onDeleteTag(tag)
                  )
                }>
                  Delete Tag
                </Button>
              }
              <Button variant="text" size="large" onClick={handleClose}>
                Cancel
              </Button>
            </Stack>
          </FormGroup>
        </Stack>
        <ConfirmDialog
          open={isOpen}
          title={config.title}
          description={config.description}
          onConfirm={config.onConfirm}
          onClose={closeDialog}
        />
      </Box>
    </Modal>
  )
}